<template>
  <div class="page-content-container" v-loading="loading">
    <div class="page-content-header flex">
      <div class="header-title">我的选题</div>
      <el-button
        class="header-btn"
        size="small"
        type="primary"
        icon="el-icon-plus"
        @click="(create = true), (type = 2)"
        v-if="
          authPermissions.includes(
            'feedback_service.api.jiker_fuwu_admin.project_applications.store'
          )
        "
        >提交新选题</el-button
      >
    </div>
    <div class="page-content-body">
      <div v-if="dataList.length">
        <div class="content-item" v-for="item in dataList" :key="item.id">
          <div class="flex" style="justify-content: space-between;">
            <div class="content-item-title">{{ item.title }}</div>
            <el-button size="mini" @click="handleToDetail(item)"
              >查看详情</el-button
            >
          </div>
          <div class="content-item-text">{{ item.description }}</div>
          <div class="content-item-info flex">
            <div class="item-info-time">
              {{ item.apply_at }}
            </div>
            <div class="flex">
              <div
                v-if="!(item.status == 3)"
                :class="['item-info-status', item.status == 2 ? 'success' : '']"
              >
                {{ statusList[item.status - 1] }}
              </div>
              <div
                v-else
                class="flex"
                style="cursor: pointer;"
                @click="handleReject(item)"
              >
                <div class="item-info-status error">
                  {{ statusList[item.status - 1] }}
                </div>
                <div class="item-info-error" v-if="item.status == 3">
                  <i class="el-icon-arrow-right"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="page-content-no" v-else>
        <img
          class="content-no-img"
          src="@/assets/images/home/img-no-data.png"
          alt=""
        />
        <div class="content-no-text">暂无数据</div>
      </div>
    </div>
    <el-drawer
      :visible.sync="create"
      :size="848"
      :with-header="false"
      direction="rtl"
      @close="handleCloseDrawer"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="create-box" v-loading="drawerLoading">
        <div class="create-content">
          <div class="create-header flex">
            <div>提交新选题</div>
            <i class="el-icon-close" @click="create = false"> </i>
          </div>
          <div class="create-body">
            <el-form
              ref="form"
              label-position="left"
              :model="formData"
              style="height:100%"
              label-width="94px"
            >
              <el-form-item label="选题名称：" class="desc-form-title" required>
                <el-input
                  size="mini"
                  placeholder="请输入名称，建议不超过40字"
                  v-model="formData.title"
                ></el-input>
              </el-form-item>
              <el-form-item
                class="desc-form-item"
                label="选题大纲&详情描述："
                required
              >
                <Markdown
                  class="desc-markdown"
                  :value.sync="formData.description"
                  ref="contentInfo"
                  defaultOpen="edit"
                  space="_for_challenge_sub_project"
                  folder="admin"
                ></Markdown>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="create-foot" v-if="type == 2">
          <div class="create-foot-btn">
            <el-button size="small" @click="create = false">取消</el-button>
            <el-button size="small" type="primary" @click="handleSubmit"
              >确定</el-button
            >
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      :visible.sync="rejectDrawer"
      :size="560"
      :with-header="false"
      direction="rtl"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="rejectDrawer-box" v-loading="drawerLoading">
        <div class="rejectDrawer-header flex">
          <div>驳回信息</div>
          <i class="el-icon-close" @click="rejectDrawer = false"> </i>
        </div>
        <div class="rejectDrawer-body">
          <div class="reject-item">
            <div class="reject-item-info ">
              <div class="flex" style="justify-content: space-between;">
                <div>时间：{{ rejectInfo.handle_at }}</div>
                <div>
                  操作人：{{
                    rejectInfo.user.realname
                      ? rejectInfo.user.realname
                      : rejectInfo.user.name
                  }}
                </div>
              </div>
              <div class="reject-item-content">
                <markdown-it-show
                  :md="rejectInfo.reject_reason"
                ></markdown-it-show>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-drawer
      :visible.sync="detailDrawer"
      :size="848"
      :with-header="false"
      direction="rtl"
      :append-to-body="true"
      :modal-append-to-body="false"
    >
      <div class="detailDrawer-box" v-loading="drawerLoading">
        <div class="detailDrawer-header flex">
          <div>选题详情</div>
          <i class="el-icon-close" @click="detailDrawer = false"> </i>
        </div>
        <div class="detailDrawer-body">
          <div class="body-info">
            <div class="flex" style="justify-content: space-between;">
              <div class="body-top-text">时间：{{ currentData.apply_at }}</div>
              <div class="body-top-text">
                操作人：{{
                  currentData.user.realname
                    ? currentData.user.realname
                    : currentData.user.name
                }}
              </div>
            </div>
            <div class="body-content">
              <div class="body-content-text title">选题名称：</div>
              <div class="body-content-text">{{ currentData.title }}</div>
              <div class="body-content-text title">选题详情：</div>
              <MarkdownItShow :md="currentData.description"></MarkdownItShow>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Markdown from "@/components/Markdown";
import MarkdownItShow from "@jiker/markdown-it/MarkdownIt.vue";
import feedbackService from "../../global/service/feedback";
import { mapState } from "vuex";

export default {
  components: { Markdown, MarkdownItShow },
  data() {
    return {
      loading: false,
      dataList: [],
      statusList: ["待审核", "已立项", "审核未通过"],
      drawerLoading: false,
      create: false,
      formData: { title: "", description: "" },
      pagination: {
        currentPage: 1,
        pageSize: 50,
        total: 0
      },
      rejectDrawer: false,
      rejectInfo: {
        user: {}
      },
      type: 0,
      currentData: { user: {} },
      detailDrawer: false
    };
  },
  computed: {
    ...mapState(["authPermissions"])
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        page_size: this.pagination.pageSize
      };
      feedbackService
        .getTopicList(params)
        .then(res => {
          this.dataList = res.list;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSubmit() {
      feedbackService
        .submitTopicInfo(this.formData)
        .then(() => {
          this.$message.success("创建选题成功");
        })
        .finally(() => {
          this.create = false;
          this.getData();
        });
    },
    handleCloseDrawer() {
      this.formData = { title: "", description: "" };
    },
    handleToDetail(data) {
      this.currentData = data;
      // this.formData = { title: data.title, description: data.description };
      // this.create = true;
      this.detailDrawer = true;
    },
    handleReject(data) {
      this.rejectInfo = data;
      this.rejectDrawer = true;
    }
  }
};
</script>
<style lang="less" scoped>
.desc-form-title {
  /deep/.el-form-item__content {
    margin-left: 80px !important;
  }
  /deep/.el-form-item__label {
    width: 80px !important;
    padding: 0 !important;
  }
}
.desc-form-item {
  height: 100%;
  /deep/.el-form-item__label {
    float: none;
  }
  /deep/.el-form-item__content {
    height: 84%;
    margin-left: 0px !important;
  }
  .desc-markdown {
    margin-top: 8px;
    height: 100%;
    box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.08) !important;
  }
}
/deep/.v-note-wrapper {
  height: 100%;
}
.page-content-container {
  height: 100%;
  .page-content-header {
    justify-content: space-between;
    .header-title {
      font-size: 18px;
      color: #303133;
    }
    .header-btn {
      width: 114px;
      height: 32px;
      // background: #409eff;
      border-radius: 3px;
      font-size: 14px;
      padding: 4px;
      font-weight: 400;
      /deep/.el-button [class*="el-icon-"] + span {
        margin-left: 2px !important;
      }
    }
  }
  .page-content-body {
    margin-top: 24px;
    height: calc(100% - 50px);
    overflow-y: auto;
    .page-content-no {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      .content-no-img {
        width: 98px;
        height: 80px;
        object-fit: cover;
      }
      .content-no-text {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .content-item {
      width: 100%;
      height: 172px;
      background: #f9f9f9;
      border-radius: 4px;
      padding: 24px 20px;
      margin-bottom: 16px;
      .content-item-title {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        width: 572px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        color: rgba(0, 0, 0, 0.85);
      }
      .content-item-text {
        width: 100%;
        height: 48px;
        margin: 12px 0 24px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;

        line-height: 22px;
        color: rgba(0, 0, 0, 0.65);
        overflow: hidden;
        text-overflow: ellipsis;
        -webkit-line-clamp: 2;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .content-item-info {
        justify-content: space-between;
        .item-info-time {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.45);
        }
        .item-info-status {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #fa8c16;
          &.success {
            color: #36b355;
          }
          &.error {
            color: #f56c6c;
          }
        }
        .item-info-error {
          width: 16px;
          height: 16px;
          line-height: 16px;
          color: #fff;
          background: #f56c6c;
          border-radius: 50%;
          font-size: 12px;
          text-align: center;
          margin-left: 4px;
        }
      }
    }
  }
}
.flex {
  display: flex;
  align-items: center;
}
.create-box {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .create-content {
    height: calc(100vh - 52px);
  }
  .create-foot {
    width: 100%;
    height: 52px;
    border-top: 1px solid #f0f0f0;
    padding: 10px;
    .create-foot-btn {
      float: right;
    }
  }
  .create-header {
    justify-content: space-between;
    padding: 16px 24px;
    height: 56px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    i {
      cursor: pointer;
    }
  }
  .create-body {
    padding: 24px 20px;
    height: calc(100% - 56px);
  }
}
.rejectDrawer-box {
  height: 100%;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  .rejectDrawer-header {
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    i {
      cursor: pointer;
    }
  }
  .rejectDrawer-body {
    padding: 0 24px 20px;
    .reject-item {
      .reject-item-info {
        justify-content: space-between;
        font-size: 14px;
        margin-top: 32px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        .reject-item-content {
          margin-top: 12px;
          width: 100;
          padding: 16px;
          background: rgba(0, 0, 0, 0.02);
          border-radius: 2px;
        }
      }
    }
  }
}
.detailDrawer-box {
  height: 100%;
  width: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  .detailDrawer-header {
    justify-content: space-between;
    padding: 16px 24px;
    border-bottom: 1px solid rgba(217, 217, 217, 1);
    div {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
    }
    i {
      cursor: pointer;
    }
  }
  .detailDrawer-body {
    padding: 20px 24px;
    height: calc(100vh - 56px);
    .body-info {
      height: 100%;
      .body-top-text {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
      }
      .body-content {
        margin-top: 12px;
        background: #fafafa;
        padding: 16px;
        height: calc(100% - 38px);
        overflow-y: auto;
        .body-content-text {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(0, 0, 0, 0.85);
          line-height: 22px;
          margin-bottom: 18px;
          &.title {
            color: rgba(0, 0, 0, 0.45);
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
</style>
